import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import GetWhoLoggedOn from './GetWhoLoggedOn.gql';

export const useWhoLoggedOn = (options) => {
  return useQuery(GetWhoLoggedOn, {
    ...options,
    url: ApiUrl.graphQl(),
    requestPolicy: 'no-cache',
  });
};
